import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {RiskAssessmentForm} from 'src/app/risk-assessment-code/RiskAssessmentCodeForm/RiskAssessmentForm';
import {racDocumentTitle} from 'src/app/risk-assessment-code/riskAssessmentHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const CreateRiskAssessmentCodePage = () => {
  useSetDocumentTitle(racDocumentTitle);

  return (
    <ContentWrapper>
      <RiskAssessmentForm mode="create" view="content" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.RiskAssessmentCreate(),
  element: <CreateRiskAssessmentCodePage />,
  module: ModuleEnum.RiskAssessmentCodes,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateRiskAssessmentCodePage;
